/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Noeditor1Inputs */

const de__filter_noeditor1 = /** @type {(inputs: _Filter_Noeditor1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Editor`)
};

/**

* @param {_Filter_Noeditor1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_noeditor1 = /** @type {((inputs?: _Filter_Noeditor1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Noeditor1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__filter_noeditor1(inputs)
});
export { _filter_noeditor1 as "_filter_noEditor" }